import type { MissionVisionSpiel } from "./types";

export const missionVision: MissionVisionSpiel = {
  missionLabel: "Mission",
  mission:
    "Build lean products that give startups an unfair advantage. Founders launch fast, change direction without a rewrite, and grow without a bloated team.",

  visionLabel: "Vision",
  vision:
    "The unit companies send on the hard jobs. We're not here to win agency awards. We're here to build software real people use.",

  optionalBeat: null,
};
